import React, { useState } from "react"
import CustomDialog, { CustomDialogProps } from "../Atoms/CustomDialog"

interface PreviewImageProps
  extends Omit<CustomDialogProps, "isOpen" | "onClose"> {
  src?: string
  height?: string
  width?: string
  alt?: string
  imgClassName?: string
}
const PreviewImage = ({
  title,
  src,
  alt,
  height,
  width,
  imgClassName,
  ...otherProps
}: PreviewImageProps) => {
  const [isOpen, setOpen] = useState(false)
  return (
    <>
      {src ? (
        <img
          onClick={e => setOpen(true)}
          className={imgClassName}
          style={{
            cursor: "pointer",
            borderRadius: 5,
          }}
          src={src}
          height={height}
          width={width}
          alt={alt}
        />
      ) : (
        "NA"
      )}

      <CustomDialog
        light
        scrollable={false}
        onClose={e => setOpen(false)}
        icon="camera"
        title={title}
        {...otherProps}
        isOpen={isOpen}
      >
        <img
          onClick={e => setOpen(true)}
          style={{
            cursor: "pointer",
            borderRadius: 5,
          }}
          src={src}
          alt={alt}
          height="100%"
          width="100%"
        />
      </CustomDialog>
    </>
  )
}
PreviewImage.defaultProps = {
  width: "25",
  height: "25",
}
export default PreviewImage
